// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3mfuX","header":"MessagesList_header__3DZag","chat":"MessagesList_chat__1efge"};